import { render } from "./beOverdue.vue?vue&type=template&id=62cd5b8e&scoped=true"
import script from "./beOverdue.vue?vue&type=script&lang=js"
export * from "./beOverdue.vue?vue&type=script&lang=js"

import "./beOverdue.vue?vue&type=style&index=0&id=62cd5b8e&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cd5b8e"]])

export default __exports__